import { Toaster as Sonner, ToasterProps } from "sonner";

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner closeButton theme="light" className="toaster group" {...props} />
  );
};

export { Toaster };
export { toast } from "sonner";
